export enum ScenarioTypeSpeedType {
  Slow = 0x00,
  Moderate = 0x01,
  Fast = 0x02,
  Fastest = 0x03,
}
